module.exports = __webpack_public_path__ + "static/media/Pink_Button.bb70da4a.png";